import { render, staticRenderFns } from "./SellingInfoWholesale.vue?vue&type=template&id=397349da&scoped=true&"
import script from "./SellingInfoWholesale.vue?vue&type=script&lang=js&"
export * from "./SellingInfoWholesale.vue?vue&type=script&lang=js&"
import style0 from "./SellingInfoWholesale.vue?vue&type=style&index=0&id=397349da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397349da",
  null
  
)

export default component.exports